import { render, staticRenderFns } from "./SortDefinition.vue?vue&type=template&id=55938075&scoped=true"
import script from "./SortDefinition.vue?vue&type=script&lang=js"
export * from "./SortDefinition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55938075",
  null
  
)

export default component.exports